import {Component, Input, OnInit} from '@angular/core';
import {Notification, NotificationResult, Token} from '../app.model';
import {AppService} from '../app.service';
import {CacheService} from '../cache.service';
import * as moment from 'moment-timezone';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import {CommonDialogComponent} from '../common-dialog/common-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { query } from '@angular/animations';
import { get, isEmpty, isNull, map, pullAllBy, toNumber } from 'lodash-es';
import { NotificationService } from '../services/notification/notification.service';
@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  @Input() notificationsFor: string;
  @Input() hideTitle = false;

  notifications: Notification[] = [];
  filteredNotifications: Notification[] = [];
  private since = 0;
  private loggedIn = false;
  private userId = 0;
  notificationReturned = false;
  notificationErrorCount = 0;
  notificationAlertCount = 0;
  notificationInfoCount = 0;
  notificationConfirmCount = 0;
  errorFilter = 'inactive';
  infoFilter = 'inactive';
  alertFilter = 'inactive';
  confirmFilter = 'inactive';
  notificationTitle = '';
  showAll = true;
  loading = false;
  timeZone = '';
  notificationType = 'ALL'
  notificationOptions = [
    {displayName:'All', type: 'ALL'},
    {displayName:'Error', type: 'ERROR'},
    {displayName:'Info', type: 'INFO'},
    {displayName:'Success', type: 'CONFIRM'},
    {displayName:'Warning', type: 'ALERT'},

  ]
  paginationPreviousFlagRecord;
  paginationInfo = {
    totalItems: 0,
    pageSize: 20,
    pageIndex: 0,

  }
  manualPageIndex = 0;
  currentFilter = 'ALL';


 // paginationNextFlagRecord;
  constructor(private appService: AppService, private cacheService: CacheService, private firestore: AngularFirestore,
    private dialog: MatDialog, private notificationService: NotificationService,
    private snackBar: MatSnackBar) {
  }

  ngOnInit() {
    if (this.cacheService.getObject('saras_auth_key')) {
      this.init();
    }
    this.appService.getUserLoginEvent().subscribe({
      next: (login) => {
        if (login) {
          this.init();
        } else {
          this.cacheService.clear();
          this.loggedIn = false;
          this.userId = 0;
          this.notifications = [];
        }
      }
    });
  }

  private init() {
    const saras_auth_key = this.cacheService.getObject<Token>('saras_auth_key');
    const userDetails = this.cacheService.getObject<any>('user_details');
    if (saras_auth_key) {
      this.loggedIn = true;
      this.userId = saras_auth_key.userId;
      this.getTimeZone(userDetails.userId, true);
    }
  }

  getTimeZone(userId: number, runNotifications = false) {
    const currentStamp = +new Date();
    this.appService.getPreferenceById(userId, 1).then(data => {
      this.timeZone = data.value;
      if (runNotifications) {
        //this.runNotifications();
        // this.appService.getNotifications().subscribe({
        //   next: (notifications) => {console.log("hellllonotifications")
        //     this.notifications = notifications;//console.log("hellllo",notifications)
        //     //this.filterNotifications();
        //     this.notifications.forEach(notification => {
        //       notification.title = this.appService.notificationTitle(currentStamp - notification.createdDate,notification.createdDate, this.timeZone)
        //     })
        //     if(this.notificationType === 'ALL'){ this.filteredNotifications = this.notifications; }
        //     else { this.changeNotificationType(this.notificationType)}
        //     this.notificationReturned = true;
        //   }
        // });
        if (!isEmpty(this.notificationsFor)) {
          this.fetchnotifications(this.notificationsFor);
        } else {
          this.fetchnotifications();
        }
      }
    });
  }

  changeNotificationType(type){
    this.notificationReturned = false;
    this.filteredNotifications = [];
    this.currentFilter = type;
    this.filteredNotifications = this.notifications.filter(notif=> (type === 'ALL' || notif.type === type))

    this.notificationReturned = true;
  }

  private runNotifications() {
  //  console.log('runing notification');
    this.filterNotifications();
  }

  getNotificationType(type){
    switch(type){
      case 'ALERT': return 'warning';
      case 'CONFIRM': return 'success';
      case 'INFO': return 'info';
      case 'ERROR': return 'error';
    }
  }

  getIconType(type) {
    switch(type){
      case 'ALERT': return 'fa-exclamation-circle';
      case 'CONFIRM': return 'fa-check-circle';
      case 'INFO': return 'fa-info-circle';
      case 'ERROR': return 'fa-times-circle';
    }

  }



  ifTitle(notification, index){
    if(index === 0 ){ this.notificationTitle = '' }
    if(this.notificationTitle === '' || !(notification.title === this.notificationTitle) ){
      this.notificationTitle = notification.title;
      return true
    }else {
      this.notificationTitle = notification.title;
      return false
    }


  }

  changeFilter(type: string) {
    if (type === 'error') {
      this.errorFilter = (this.errorFilter === 'inactive') ? 'active' : 'inactive';
    } else if (type === 'alert') {
      this.alertFilter = (this.alertFilter === 'inactive') ? 'active' : 'inactive';
    } else if (type === 'info') {
      this.infoFilter = (this.infoFilter === 'inactive') ? 'active' : 'inactive';
    } else if (type === 'confirm') {
      this.confirmFilter = (this.confirmFilter === 'inactive') ? 'active' : 'inactive';
    }

    if (this.alertFilter === 'active' && this.errorFilter === 'active' && this.infoFilter === 'active' && this.confirmFilter === 'active') {
      this.showAll = true;
    } else if (this.alertFilter === 'inactive' && this.errorFilter === 'inactive'
      && this.infoFilter === 'inactive' && this.confirmFilter === 'inactive') {
      this.showAll = true;
    } else {
      this.showAll = false;
    }

    //this.filterNotifications();
    this.filteredNotifications = this.notifications;
    this.notificationReturned = true;
  }

  clearAllNotifications() {

    const dialogRef = this.dialog.open(CommonDialogComponent, {
      data: {
        title: 'Delete Notifications',
        content: 'All notifications on this page will be deleted.',
        optionLine: 'Do you wish to continue?',
        image: 'integration delected',
        buttons: [
          {
            'title': 'YES',
            'meta': '',
            'type': 'delete',
            'class': 'confirm-dialog-later'
          },

          {
            'title': 'NO',
            'meta': '',
            'type': 'no-change',
            'class': 'confirm-dialog-proceed'
          }
        ]
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result?.type === 'delete') {
        this.deleteBulkNotifications(this.filteredNotifications);
      }
    });
  }

  filterNotifications() {
    let notificationErrorCount = 0;
    let notificationAlertCount = 0;
    let notificationInfoCount = 0;
    let notificationConfirmCount = 0;
    this.filteredNotifications = [];
    this.notifications.forEach(notification => {
      switch (notification.type) {
        case 'ERROR':
          notificationErrorCount += 1;
          if (this.showAll || this.errorFilter === 'active') {
            this.filteredNotifications.push(notification);
          }
          break;
        case 'ALERT':
          notificationAlertCount += 1;
          if (this.showAll || this.alertFilter === 'active') {
            this.filteredNotifications.push(notification);
          }
          break;
        case 'INFO':
          notificationInfoCount += 1;
          if (this.showAll || this.infoFilter === 'active') {
            this.filteredNotifications.push(notification);
          }
          break;
        case 'CONFIRM':
          if (this.showAll || this.confirmFilter === 'active') {
            this.filteredNotifications.push(notification);
          }
          notificationConfirmCount += 1;
          break;
      }

      this.notificationErrorCount = notificationErrorCount;
      this.notificationAlertCount = notificationAlertCount;
      this.notificationInfoCount = notificationInfoCount;
      this.notificationConfirmCount = notificationConfirmCount;
    });
    this.notificationReturned = true;
  }

  private indexOf(notification: Notification): number {
    for (let i = 0; i < this.notifications.length; i++) {
      if (notification.notificationId === this.notifications[i].notificationId) {
        return i;
      }
    }
    return -1;
  }

/*
   getPreviousRecord() {
        // this.notifications = []
        // this.filteredNotifications = []
        const record = this.paginationPreviousFlagRecord
        const currentStamp = +new Date();
        console.log(record.id,"recordpre")
        this.firestore.collection('panel-notifications')//.ref.where('fulladdress', '==', myString)
        .ref.where('userId', '==', this.userId).where('status', 'in', ['SHOW', 'CREATED','VIEWED'])
        .orderBy("updatedDate", "desc")
        .startAfter(record)
        .limit(20)
        .get()
        .then(notifications => {
          this.paginationPreviousFlagRecord = notifications.docs[notifications.docs.length-1];
        //  this.paginationNextFlagRecord = notifications.docs[0]
         // this.paginationNextFlagRecord = notifications.docs[0];
         // console.log("notification",lastVisible)
         notifications.forEach(notification=> {
          const id = notification.id;console.log(id,"pre")
          const data = notification.data();
         // const obj = {notificationId: parseInt(id) , ...data }
          const returnedTarget = Object.assign({notificationId: id}, data)
          //@ts-ignore
          this.notifications.push(returnedTarget)
        //  this.notifications.sort((a,b) => (a.updatedDate < b.updatedDate) ? 1 : ((b.updatedDate < a.updatedDate) ? -1 : 0)); //console.log(this.notifications,"XXX")
          this.notifications.forEach(notification => {
            notification.title = this.appService.notificationTitle(currentStamp - notification.createdDate,notification.createdDate, this.timeZone)
          })
          if(this.notificationType === 'ALL'){ this.filteredNotifications = this.notifications; }
          else { this.changeNotificationType(this.notificationType)}
          this.notificationReturned = true;
       // console.log(returnedTarget,"eee")
        });

        })

  }

  private fetchnotifications() {
    const currentStamp = +new Date();
    this.firestore.collection('panel-notifications', ref =>
    ref.where('userId', '==', this.userId).where('status', 'in', ['SHOW','VIEWED','CREATED'])
    .orderBy("updatedDate", "desc").limit(20)
     // .orderBy('updated', 'desc')
      ).snapshotChanges()//.valueChanges()
      .subscribe((notifications: Array<any>) => {
      //  var lastVisible = notifications.;
    //    console.log("last", notifications[(notifications.length - 1)], notifications);
      //  this.getPreviousRecord(notifications[(notifications.length - 1)].payload.doc.data())


        this.notifications = notifications.map((notification,i)=> {

          if( i === notifications.length - 1) { this.paginationPreviousFlagRecord = notification.payload.doc ; }

         // if( i === 0) { this.paginationNextFlagRecord = notification.payload.doc ; }

          const id = notification.payload.doc.id;//console.log(id,"base")
          const data = notification.payload.doc.data();
          return {notificationId: id,...data}
        });

      //  this.notifications.sort((a,b) => (a.updatedDate < b.updatedDate) ? 1 : ((b.updatedDate < a.updatedDate) ? -1 : 0)); //console.log(this.notifications,"XXX")
        this.notifications.forEach(notification => {
          notification.title = this.appService.notificationTitle(currentStamp - notification.createdDate,notification.createdDate, this.timeZone)
        })
        if(this.notificationType === 'ALL'){ this.filteredNotifications = this.notifications; }
        else { this.changeNotificationType(this.notificationType)}
        this.notificationReturned = true;

       })

}

  close(notification: Notification, result: string) {
    const id = notification.notificationId
    this.firestore.doc(`panel-notifications/${id}`).update({status: 'CLOSED'});

  }
*/

  private resetNotificationsToEmpty(): void {
    this.filteredNotifications = [];
    this.notifications = [];
    this.notificationReturned = true;
  }

pageChange(e, type?) {
  this.notificationReturned = false;
  this.paginationInfo.pageIndex = e - 1 ;
  this.manualPageIndex =  e - 1 ;
  this.appService.getNotifications_vm(this.userId, this.paginationInfo, this.notificationsFor)
  .then(response => {
    this.filteredNotifications = get(response, 'content', []);
    this.paginationInfo.pageIndex = e;
    if (type === 'onDelete') {
      this.paginationInfo.pageIndex = 1;
    }
    this.notifications = get(response, 'content', []);
    this.changeNotificationType(this.currentFilter);
    this.notificationReturned = true;
  }).catch((err) => {
    console.error('pageChange: getNotifications_vm failed', err);
    this.resetNotificationsToEmpty();
    this.snackBar.open(
      'Failed to load notifications. Please try again.', '',
      {duration: 2500, verticalPosition: 'top', horizontalPosition: 'center', panelClass: ['reload-snack-bar']});
  })
}
/*
getServerData(e) { console.log(e)
   this.notificationReturned = false;
   this.paginationInfo.pageIndex = e.pageIndex;
   this.paginationInfo.pageSize = e.pageSize;

  this.appService.getNotifications_vm(this.userId, this.paginationInfo).then(response => {
    this.paginationInfo.totalItems = response.totalElements;
    this.paginationInfo.pageSize = response.pageable.pageSize;
    this.paginationInfo.pageIndex = response.pageable.pageNumber;
    this.filteredNotifications = response.content
    this.notificationReturned = true;

  })
}
*/
fetchnotifications(fetchParams?) {
  this.appService.getNotifications_vm(this.userId, this.paginationInfo, fetchParams).then((response) => {
    if (response === null) {
      this.resetNotificationsToEmpty();
      return;
    }
    localStorage.setItem('viewedNotificationsAt', ((new Date()).getTime()).toString());
    this.appService.viewedNotificationsAt = toNumber(localStorage.getItem('viewedNotificationsAt'));
    this.paginationInfo.totalItems = response.totalElements ?? 0;
    this.paginationInfo.pageSize = response.pageable?.pageSize ?? this.paginationInfo.pageSize;
    this.paginationInfo.pageIndex = response.pageable?.pageNumber ?? 0;
    this.filteredNotifications = response.content ?? [];
    this.notifications = response.content ?? [];
    this.notificationReturned = true;
  }).catch((err) => {
    console.error('fetchnotifications: getNotifications_vm failed', err);
    this.resetNotificationsToEmpty();
  })
}

async deleteNotification(notification) {

  try {
    const response = await this.notificationService.deleteNotification(notification.id);
    if (isNull(response)) {

      this.filteredNotifications =  pullAllBy(this.filteredNotifications, [notification], 'id');
      this.snackBar.open(
        'Notification deleted successfully', '',
        {duration: 2500, verticalPosition: 'top', horizontalPosition: 'center', panelClass: ['reload-snack-bar']});
    }
  } catch (error) {
    this.snackBar.open(
      get(error, 'error.errors.0.message') || '', '',
      {duration: 2500, verticalPosition: 'top', horizontalPosition: 'center', panelClass: ['reload-snack-bar']});
  }
}

async deleteBulkNotifications(notifications) {
  try {
    const response = await this.notificationService.deleteBulkNotifications(notifications);
    if (isNull(response)) {
      this.filteredNotifications =  pullAllBy(this.filteredNotifications, [...notifications], 'id');
      this.snackBar.open(
        'Notification deleted successfully', '',
        {duration: 2500, verticalPosition: 'top', horizontalPosition: 'center', panelClass: ['reload-snack-bar']});
        this.pageChange(this.paginationInfo.pageIndex + 1, 'onDelete');
    }
  } catch (error) {
    this.snackBar.open(
      get(error, 'error.errors.0.message') || '', '',
      {duration: 2500, verticalPosition: 'top', horizontalPosition: 'center', panelClass: ['reload-snack-bar']});
  }
}
}
